import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Vantage settings has no landing of its own — a parent row in the nav is a
 * disclosure, not a destination — so /settings/vantage lands on Cases.
 */
export const Route = createFileRoute('/$clusterId/$scopeId/settings/vantage/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$clusterId/$scopeId/settings/vantage/cases', params, replace: true })
  },
})
